import { Orientacao } from './enum';

export class PerfilEstrutura {
  id: number;
  orientacao: Orientacao;
  larguraModulo: number;
  idMaxPainel: number;
  tamPerfil: number;
  qtdModuloPorLinha: number;
  qtd: number;
  tamMaxPainel: number;
}
